__turbopack_context__.v({
  "container": "Spinner-module__E7Q7Xa__container",
  "spin": "Spinner-module__E7Q7Xa__spin",
});
